export default "__VITE_ASSET__CpHZTUZN__"